import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from 'aurelia-dependency-injection';
import { StringUtilities } from "../../../utilities/strings";
import { AttachmentsHelper } from '../../../utilities/attachments-helper';
import { computedFrom } from 'aurelia-binding';
import { Reflection } from '../../../utilities/reflection';

@autoinject()
export class PdfViewer {

    private _onViewerClosed: any;
    private _interval: any;
    private _isRendered: boolean;

    public hideHeader: boolean = false;
    public url: string;

    @computedFrom(Reflection.getPropertyPath<PdfViewer>(z => z._isRendered))
    public get isRendered(): boolean {
        return this._isRendered;
    }

    public constructor(private dialogClientService: DialogClientService) { }

    public activate(params) {

        if (!params) {
            return;
        }

        this.hideHeader = params.hideHeade
        this._onViewerClosed = params.onViewerClosed;
        const link: string = params.link;
        if (!StringUtilities.endsWith(link, '.pdf') && !params.doNotAddExtension) {
            params.link = params.link + '.pdf'
        }

        this.url = params.isDataUrl ? params.link : AttachmentsHelper.getUrl(params.link);

        if (params.isDataUrl || !StringUtilities.startsWith(this.url, location.origin) || params.doNotAddExtension) {
            this._isRendered = true;
        } else {
            this._interval = setInterval(() => {
                $.ajax({
                    type: 'HEAD',
                    url: this.url,
                    headers: { "x-ms-meta-target": "" },
                    success: () => {
                        this._isRendered = true;
                        this.url += ("?" + Math.random());
                        clearInterval(this._interval);
                    },
                    error: () => {
                        clearInterval(this._interval);
                    }
                });
            }, 3000);
        }
    }

    public detached() {
        clearInterval(this._interval);
    }

    public goBack() {
        this.dialogClientService.hide();
        if (this._onViewerClosed) {
            this._onViewerClosed();
        }
    }
}
